import React from "react";

const CatalogStatusWidget: React.FC = () => {
  return (
    <div className="widget">
      <h2 className="text-lg font-bold mb-2">Catalog status</h2>
      <img
        src="/images/CatalogStatusWidget.png"
        alt="Catalog status Chart"
        className="w-full h-auto"
      />
    </div>
  );
};

export default CatalogStatusWidget;
